export default "__VITE_ASSET__6879a06f__"